export default function isSameCodeItem<T extends { code: string; id?: string }>(item: T, otherItem: T): boolean {
  return item.id || otherItem.id ? item.id === otherItem.id : item.code === otherItem.code;
}
